var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSidebarLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "42px",
    viewBox: "0 0 38 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Side-Menu",
    transform: "translate(-30.000000, -34.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.000000, 34.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9678885,14.3022932 L13.9678885,20.788702 C13.9678885,22.1525578 14.7515083,23.3950778 15.9822665,23.9827315 L21.6465616,26.6872792 L21.6465616,32.0067035 C21.6465616,32.2064866 21.5298391,32.3878481 21.3480011,32.4706021 L0.720798464,41.8579856 C0.464594329,41.9745834 0.162378648,41.8614101 0.0457808469,41.6052059 C0.0156108809,41.5389125 2.52468401e-14,41.4669227 2.42028619e-14,41.3940869 L-4.27435864e-14,20.9056107 C-4.27681647e-14,20.704914 0.117779764,20.5229007 0.300858432,20.4406732 L13.9678885,14.3022932 Z",
    id: "Shape",
    opacity: 0.695200893
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7663415,10.8205402 L37.7663415,31.3007519 C37.7663415,31.5822401 37.5381502,31.8104314 37.256662,31.8104314 C37.1794495,31.8104314 37.1032461,31.7928886 37.0338057,31.7591276 L16.406603,21.7304465 C16.231147,21.6451421 16.1197799,21.4671649 16.1197799,21.2720709 L16.1197799,0.542245162 C16.1197799,0.260756963 16.3479712,0.0325656917 16.6294594,0.0325656917 C16.7083487,0.0325656917 16.7861611,0.050878438 16.8567701,0.0860620847 L37.4839727,10.3643571 C37.6569873,10.4505682 37.7663415,10.6272362 37.7663415,10.8205402 Z",
    id: "Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarLogo);
export default __webpack_public_path__ + "static/media/sidebar-logo.2ca4f850.svg";
export { ForwardRef as ReactComponent };